// src/utils/eloUtils.js

const K_FACTOR = 32;

export const calculateEloRating = (winnerRating, loserRating, numComparisons) => {
  const decimals = numComparisons < 10000 ? 0 : numComparisons < 100000 ? 1 : numComparisons < 1000000 ? 2 : numComparisons < 10000000 ? 3 :4;
  const expectedWinner = 1 / (1 + Math.pow(10, (loserRating - winnerRating) / 400));
  const expectedLoser = 1 / (1 + Math.pow(10, (winnerRating - loserRating) / 400));
  
  if (decimals>0){
  const newWinnerRating = Number((winnerRating + K_FACTOR * (1 - expectedWinner)).toFixed(decimals));
  const newLoserRating = Number((loserRating + K_FACTOR * (0 - expectedLoser)).toFixed(decimals));
  return { winnerRating: newWinnerRating, loserRating: newLoserRating };}
  else{
    const newWinnerRating = Math.round(winnerRating + K_FACTOR * (1 - expectedWinner));
    const newLoserRating = Math.round(loserRating + K_FACTOR * (0 - expectedLoser));
  return { winnerRating: newWinnerRating, loserRating: newLoserRating }}
};

// export const calculateEloRating = (winnerRating, loserRating, numComparisons) => {
//   const expectedWinner = 1 / (1 + Math.pow(10, (loserRating - winnerRating) / 400));
//   const expectedLoser = 1 / (1 + Math.pow(10, (winnerRating - loserRating) / 400));
  
//   const newWinnerRating = Math.round(winnerRating + K_FACTOR * (1 - expectedWinner));
//   const newLoserRating = Math.round(loserRating + K_FACTOR * (0 - expectedLoser));
  
//   return { winnerRating: newWinnerRating, loserRating: newLoserRating };
// };

export const getRandomPair = (items) => {
  if (items.length < 2) return null;

  const firstIndex = Math.floor(Math.random() * items.length);
  let secondIndex;

  do {
    secondIndex = Math.floor(Math.random() * items.length);
  } while (secondIndex === firstIndex);

  return [items[firstIndex], items[secondIndex]];
};

export const getBestPair = (items) => {
  if (items.length < 2) return null;

  const sortedByUsage = [...items].sort((a, b) => 
    (a.wins + a.losses) - (b.wins + b.losses)
  );

  const poolSize = Math.max(2, Math.ceil(items.length / 2));
  const pool = sortedByUsage.slice(0, poolSize);

  const firstIndex = Math.floor(Math.random() * pool.length);
  const firstItem = pool[firstIndex];

  const remainingOptions = items.filter(item => item.id !== firstItem.id);
  
  const secondIndex = Math.floor(Math.random() * remainingOptions.length);
  const secondItem = remainingOptions[secondIndex];

  return [firstItem, secondItem];
};

export const sortByRating = (items) => {
  return [...items].sort((a, b) => b.elo - a.elo);
};

export const getRankIcon = (position) => {
  switch (position) {
    case 1: return '👑';
    case 2: return '🥈';
    case 3: return '🥉';
    default: return '🏅';
  }
};